// Approved pricing basis: GR-9700 motorized, freestanding, under 10 units,
// 3 m height. The old supplier quotation receives a provisional 10% increase.
export const PERGOLA_FX = 1.45;
export const PERGOLA_MARKUP = 3.3;
export const OPTION_MARKUP = 2;
export const OLD_QUOTE_FACTOR = 1.1;
export const PERGOLA_HEIGHT = '3 m (approximately 9 ft 10 in)';
export const SCREEN_USD_PER_FOOT = 44.11; // Current supplier cost; no inflation allowance.
export const roundMoney = (value: number) => Math.round((value + 1e-9) * 100) / 100;
export const supplierPriceCAD = (usd: number, markup: number, adjustment = 1) => {
  if (!Number.isFinite(usd) || usd < 0 || !Number.isFinite(markup) || markup <= 0 || !Number.isFinite(adjustment) || adjustment <= 0) {
    throw new Error('Invalid supplier pricing inputs');
  }
  return roundMoney(usd * adjustment * PERGOLA_FX * markup);
};

export const PREMIUM_SIZES = [
  { size: '10x10', widthM: 3, depthM: 3, supplierUSD: 2266 },
  { size: '10x13', widthM: 3, depthM: 4, supplierUSD: 2581 },
  { size: '10x16', widthM: 3, depthM: 5, supplierUSD: 2905 },
  { size: '10x20', widthM: 3, depthM: 6, supplierUSD: 3147 },
  { size: '10x26', widthM: 3, depthM: 8, supplierUSD: 4269 },
  { size: '13x13', widthM: 4, depthM: 4, supplierUSD: 2933 },
  { size: '13x16', widthM: 4, depthM: 5, supplierUSD: 3291 },
  { size: '13x20', widthM: 4, depthM: 6, supplierUSD: 3616 },
  { size: '13x26', widthM: 4, depthM: 8, supplierUSD: 4853 },
].map(item => ({
  ...item,
  materialsCAD: supplierPriceCAD(item.supplierUSD, 1, OLD_QUOTE_FACTOR),
  // Approved starting offer: round the 10x10 retail price up to $11,999.
  priceCAD: item.size === '10x10' ? 11999 : supplierPriceCAD(item.supplierUSD, PERGOLA_MARKUP, OLD_QUOTE_FACTOR),
}));

export const getPremiumSize = (size: string) => PREMIUM_SIZES.find(item => item.size === size);

export const getScreenFeet = (size: string, sides: string[]) => {
  const item = getPremiumSize(size);
  if (!item) throw new Error('Unsupported pergola size');
  // Use actual supplier dimensions, not rounded marketing dimensions in feet.
  return ['front', 'back', 'left', 'right'].reduce((total, side) =>
    total + (sides.includes(side) ? (side === 'front' || side === 'back' ? item.widthM : item.depthM) / 0.3048 : 0), 0);
};

export const getScreenPrice = (size: string, sides: string[]) =>
  supplierPriceCAD(SCREEN_USD_PER_FOOT * getScreenFeet(size, sides), OPTION_MARKUP);

export const getPremiumQuote = (size: string, optionsCAD = 0, siteWorkCAD = 0) => {
  const item = getPremiumSize(size);
  if (!item) throw new Error('Unsupported pergola size');
  if (![optionsCAD, siteWorkCAD].every(value => Number.isFinite(value) && value >= 0)) throw new Error('Invalid additional costs');
  const subtotal = roundMoney(item.priceCAD + optionsCAD + siteWorkCAD);
  const tax = roundMoney(subtotal * 0.13);
  return { base: item.priceCAD, installation: 0, delivery: 0, siteWork: siteWorkCAD, subtotal, tax, total: roundMoney(subtotal + tax) };
};
